var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraggableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.166 5.5c0 .917-.75 1.667-1.666 1.667-.917 0-1.667-.75-1.667-1.666 0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667zm-3.333 5c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666zm0 5c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666zM15 5.5c0 .917-.75 1.667-1.667 1.667s-1.667-.75-1.667-1.666c0-.917.75-1.667 1.667-1.667S15 4.584 15 5.501zm-3.334 5c0-.916.75-1.666 1.667-1.666S15 9.584 15 10.501c0 .916-.75 1.666-1.667 1.666s-1.667-.75-1.667-1.666zm0 5c0-.916.75-1.666 1.667-1.666S15 14.584 15 15.501c0 .916-.75 1.666-1.667 1.666s-1.667-.75-1.667-1.666z",
    fill: "#1D1E27"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hg4mavxnna",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 10,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.166 5.5c0 .917-.75 1.667-1.666 1.667-.917 0-1.667-.75-1.667-1.666 0-.917.75-1.667 1.667-1.667.916 0 1.666.75 1.666 1.667zm-3.333 5c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666zm0 5c0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666-.917 0-1.667-.75-1.667-1.666zM15 5.5c0 .917-.75 1.667-1.667 1.667s-1.667-.75-1.667-1.666c0-.917.75-1.667 1.667-1.667S15 4.584 15 5.501zm-3.334 5c0-.916.75-1.666 1.667-1.666S15 9.584 15 10.501c0 .916-.75 1.666-1.667 1.666s-1.667-.75-1.667-1.666zm0 5c0-.916.75-1.666 1.667-1.666S15 14.584 15 15.501c0 .916-.75 1.666-1.667 1.666s-1.667-.75-1.667-1.666z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIcon);
export default __webpack_public_path__ + "static/media/draggable-icon.74d6069cb97351e7442a80cec1afa4d0.svg";
export { ForwardRef as ReactComponent };